import { LiquidityNeeds } from '../../AccountOpening.meta';

export const liquidityNeedsOpts = [
  {
    label: 'Very Important',
    value: LiquidityNeeds.VeryImportant,
  },
  {
    label: 'Somewhat Important',
    value: LiquidityNeeds.SomewhatImportant,
  },
  {
    label: 'Not Important',
    value: LiquidityNeeds.NotImportant,
  },
];
